import React, { Fragment } from 'react';
import { FiArrowDown, FiArrowUp } from 'react-icons/fi';
import { Row, Col, Card, CardHeader, CardBody, Media } from 'reactstrap';
import { H5, H6 } from '../../../AbstractElements';
import { OrderDetails } from '../../../Constant';
import { Sales2Data } from '../../../Data/Widgets/general';

const Sales1 = () => {
  return (
    <Fragment>
      <Col xl='6' className='box-col-6'>
        <Card className='widget-joins'>
          <CardHeader className='pb-0'>
            <Media>
              <Media body>
                <H5>{OrderDetails}</H5>
              </Media>
            </Media>
          </CardHeader>
          <CardBody>
            <Row className='gy-4'>
              {Sales2Data.map((item) => {
                return (
                  <Col sm='6' key={item.id}>
                    <div className='widget-card'>
                      <Media className='d-flex justify-content-between align-self-center'>
                        <div className={`widget-icon sale2 flex-0-0-auto bg-light-${item.color}`}>{item.icon1}</div>
                        <Media body className='text-end'>
                          <H6>{item.title}</H6>
                          <H5>
                            {item.order}
                            <span className={`d-inline-flex gap-1 align-items-center font-roboto font-${item.color} f-w-700`}>
                              {item.gros >= 50 ? <FiArrowUp /> : <FiArrowDown />}
                              {` ${item.gros}%`}
                            </span>
                          </H5>
                        </Media>
                      </Media>
                    </div>
                  </Col>
                );
              })}
            </Row>
          </CardBody>
        </Card>
      </Col>
    </Fragment>
  );
};
export default Sales1;
